import React, { useEffect, useState } from "react";
import ViewEmployees from "./Employees/ViewEmployees";
import CompanyAPIs from "../../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import ViewCompanyHeadOffice from "./ViewCompanyHeadOffice/ViewCompanyHeadOffice";
import { FaChevronDown, FaChevronUp, FaSave } from "react-icons/fa";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdDelete, MdEdit } from "react-icons/md";
import {  useNavigate, useParams } from "react-router-dom";
import ApiResponseHandler from "../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { Form } from "react-bootstrap";
import { useToast } from "../../../../Contexts/ToastContext";
import ViewProjectTabs from "../../Projects/ManageProject/ViewProject/ViewProjectTabs/ViewProjectTabs";

export default function ViewCompany(){

    const {addToast} = useToast();
    const navigate = useNavigate();
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [editing, setEditing] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    const [companyData, setCompanyData] = useState();
    const [companyName, setCompanyName] = useState('');
    const [companyWebsite, setCompanyWebsite] = useState('');
    const [companyEmail, setCompanyEmail] = useState('');

    const tabs = [
        { key: "head-office", label: "Head Office", component: <ViewCompanyHeadOffice companyID={params.CompanyID} /> },
        { key: "employess", label: "Employees", component: <ViewEmployees CompanyID={params.CompanyID} /> },
        
    ];

    const getCompanyData = (companyID) => {
        CompanyAPIs.GetCompany(companyID)
        .then((response) => {
            if(response.status === 200){
                setCompanyData(response.data);
                setCompanyName(response.data.name);
                setCompanyWebsite(response.data.website ?? '');
                setCompanyEmail(response.data.email ?? '');
                setLoading(false);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const updateCompany = () => {
        // e.preventDefault();
        // e.stopPropagation();
        setSending(true);
        const putJSON = {
            name: companyName,
            website: companyWebsite,
            email: companyEmail,
            company_type_id: 1,
        }

        if(companyName !== ''){
            CompanyAPIs.PutCompany(params.CompanyID, putJSON)
            .then((response) => {
                if(response.status === 200){
                    setEditing(false);
                    getCompanyData(params.CompanyID);
                    setSending(false);
                    addToast({ message: "Company updated successfully!", variant: "success", autoHide: true });
                }
            }) 
            .catch((err) => {
                setSending(false);
                ApiResponseHandler(err.response, navigate);
            })
        }
    }

    const deleteCompany = () => {
        setSending(true);
        CompanyAPIs.DeleteCompany(params.CompanyID)
        .then((response) => {
            if(response.status === 200){
                setSending(false);
                navigate('/companies');
                addToast({ message: "Company deleted successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })
    }

    const handleCancel = () => {
        setCompanyName(companyData.name);
        setEditing(false);
    }

    const handleDelete = () => {
        if(window.confirm('Are you sure you want to delete ' + companyData.name + 'from system?')){
            deleteCompany();
        }
    }

    useEffect(() => {
        getCompanyData(params.CompanyID);
    }, [params.CompanyID]);


    useEffect(() => {
            let ticking = false;
    
            const TOP_OFFSET = 10; // when to reset (near top)
            const SHRINK_OFFSET = 150; // when to shrink
    
            const updateScrollState = () => {
                const scrollY = window.scrollY;
    
                if (scrollY > SHRINK_OFFSET) {
                    setIsScrolled(true); // shrink once
                } else if (scrollY < TOP_OFFSET) {
                    setIsScrolled(false); // only expand at top
                }
    
                ticking = false;
            };
    
            const handleScroll = () => {
                if (!ticking) {
                    ticking = true;
                    window.requestAnimationFrame(updateScrollState);
                }
            };
    
            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }, []);

    if(loading){
        return(<div>Loading Company...</div>)
    }
    return(
        // <div className="company-card">
            
        //     <div className="component-card-title">
        //         <div></div>
        //         <div>
        //             {edit ? 
        //                 <button disabled={sending} onClick={() => updateCompany()}><FaSave/></button>
        //                 :
        //                 <button disabled={sending} onClick={() => handleDelete()}><MdDelete/></button>
        //             }
        //         </div>
        //         <div>
        //         {edit ?
        //             <button disabled={sending} onClick={() => handleCancel()}><MdCancel/></button>
        //             :
        //             <button disabled={sending} onClick={() => setEdit(true)}><AiFillEdit/></button>
                
        //         }
        //         </div>   
        //     </div>

        //     {edit ? 
        //     <div>
        //         <strong>Name</strong>
        //         <Form.Control value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
        //     </div>
        //         :
        //         <h2>{companyName}</h2>
        //     }
            
        //     <div className={'company-details active'}>
        //         <div className="website-line">
        //             Website: {edit ? <Form.Control value={companyWebsite} onChange={(e) => setCompanyWebsite(e.target.value)} /> : companyWebsite}
        //         </div>
        //         <div className="website-line">
        //             Email: {edit ? <Form.Control value={companyEmail} type="email" onChange={(e) => setCompanyEmail(e.target.value)} /> : companyEmail}
        //         </div>
        //         <ViewCompanyHeadOffice companyID={companyID} />

        //         <ViewEmployees CompanyID={companyID} />                
        //     </div>
        // </div>
            
            <>
        
        <div className="project-header">
            
            <div className="project-header-left">
                {editing ? 
                <Form.Control size='sm' disabled={sending} className='project-title-input editable-field' onChange={(e) => setCompanyName(e.target.value)} required value={companyName} />
                :
                <h2>{companyData.name}</h2>   
                }


                <div className={`project-meta ${isScrolled ? 'shrink' : ''}`}>

                    {editing ? 
                        <div className="meta-item">
                                    <span className="label">Email:</span>
                                    <Form.Control size='sm' type='email' disabled={sending} className='editable-field' value={companyEmail} onChange={(e) => setCompanyEmail(e.target.value)} />
                               
                                </div>
                            :
    
                        <div className="meta-item">
                            <span className="label">Email:</span>
                            <span>{companyData.email ? companyData.email : 'Not set'}</span>
                        </div>
                        }

                        {editing ? 
                            <div className="meta-item">
                                        <span className="label">Website:</span>
                                        <Form.Control 
                                            size='sm' 
                                            disabled={sending} 
                                            className='editable-field' 
                                            value={companyWebsite}
                                             onChange={(e) => setCompanyWebsite(e.target.value)}
                                        />
                            
                                    </div>
                                :
        
                            <div className="meta-item">
                                <span className="label">Website:</span>
                                <span>{companyData.website ? companyData.website : 'Not set'}</span>
                            </div>
                        }


                </div>

            </div>

            <div className={`project-header-actions ${isScrolled ? 'shrink' : ''}`}>
                {editing ? (
                    <>
                        <button disabled={sending || companyName === ''} className="save-btn" onClick={updateCompany}>{sending ? 'Saving' : 'Save'}</button>
                        <button disabled={sending} className="cancel-btn" onClick={() => handleCancel()}>Cancel</button>
                    </>
                ) : (
                    <>
                        <button disabled={sending} className="edit-btn" onClick={() => setEditing(true)}>
                            <MdEdit /> Edit
                        </button>

                        <button disabled={sending} className="delete-btn" onClick={handleDelete}>
                            <MdDelete /> {sending ? 'Deleting...' : 'Delete'}
                        </button>
                    </>
                )}
            </div>
            
        </div>

        <ViewProjectTabs tabs={tabs}/>


        
        </>
    )
    

}
